(() => {
  const root = document.querySelector('[data-shir7-story]');
  if (!root) return;

  const STORAGE_KEY = 'shir7_floating_story_closed';
  if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

  const preview = root.querySelector('[data-shir7-story-preview]');
  const openBtn = root.querySelector('[data-shir7-story-open]');
  const closeBtn = root.querySelector('[data-shir7-story-close]');
  const modal = document.querySelector('[data-shir7-story-modal]');
  const modalVideo = modal?.querySelector('[data-shir7-story-modal-video]');
  const modalClosers = modal?.querySelectorAll('[data-shir7-story-modal-close]');

  root.hidden = false;

  const markPlaying = () => {
    if (!preview) return;
    preview.classList.add('is-playing');
    preview.removeAttribute('poster');
  };

  const tryPlayPreview = () => {
    if (!preview || root.hidden) return;
    if (modal && !modal.hidden) return;

    preview.muted = true;
    preview.defaultMuted = true;
    preview.volume = 0;
    preview.playsInline = true;
    preview.loop = true;
    preview.setAttribute('muted', '');
    preview.setAttribute('playsinline', '');
    preview.setAttribute('webkit-playsinline', '');
    preview.setAttribute('autoplay', '');
    preview.removeAttribute('controls');

    // Garante source no elemento video
    if (!preview.getAttribute('src')) {
      const source = preview.querySelector('source[src]');
      if (source?.getAttribute('src')) {
        preview.src = source.getAttribute('src');
      }
    }

    const playPromise = preview.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(() => markPlaying())
        .catch(() => {
          setTimeout(() => {
            if (root.hidden || (modal && !modal.hidden)) return;
            preview.muted = true;
            preview.volume = 0;
            preview.play()?.then(markPlaying).catch(() => {});
          }, 350);
        });
    }

    if (!preview.paused) markPlaying();
  };

  const start = () => {
    tryPlayPreview();
    [50, 200, 500, 1000, 2000, 4000].forEach((ms) => setTimeout(tryPlayPreview, ms));
  };

  if (preview) {
    preview.addEventListener('loadeddata', tryPlayPreview);
    preview.addEventListener('canplay', tryPlayPreview);
    preview.addEventListener('playing', markPlaying);
    preview.addEventListener('pause', () => {
      if (!root.hidden && (!modal || modal.hidden)) {
        setTimeout(tryPlayPreview, 200);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  window.addEventListener('load', tryPlayPreview, { once: true });

  // Desbloqueia em browsers que exigem gesto
  const unlock = () => {
    tryPlayPreview();
    document.removeEventListener('touchstart', unlock);
    document.removeEventListener('pointerdown', unlock);
  };
  document.addEventListener('touchstart', unlock, { once: true, passive: true });
  document.addEventListener('pointerdown', unlock, { once: true });

  const openModal = () => {
    if (!modal || !modalVideo) return;
    preview?.pause();
    modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    modalVideo.muted = false;
    modalVideo.volume = 1;
    modalVideo.currentTime = 0;
    if (typeof modalVideo.load === 'function' && modalVideo.readyState === 0) {
      modalVideo.load();
    }
    modalVideo.play()?.catch(() => {});
  };

  const closeModal = () => {
    if (!modal || !modalVideo) return;
    modal.hidden = true;
    modalVideo.pause();
    document.documentElement.classList.remove('overflow-hidden');
    tryPlayPreview();
  };

  const dismissBubble = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    closeModal();
    preview?.pause();
    root.hidden = true;
  };

  openBtn?.addEventListener('click', openModal);
  openBtn?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openModal();
    }
  });
  closeBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    dismissBubble();
  });
  modalClosers?.forEach((el) => el.addEventListener('click', closeModal));
})();
